import React, { useContext, forwardRef } from 'react'
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';

const FormTextInput = forwardRef(function FormTextInput(props, ref) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);
    const inputErrorClasses = ["outline", "outline-2", "outline-[#FD6F64]"]
    const labelErrorClasses = ["after:content-[attr(data-error-msg)]", "before:content-[attr(data-error-icon)]"]
    const { errorMessage, label, srOnlyLabel, name, extraClasses, moreInfo } = props

    function handleInputChange({ target }) {
        ref.current.classList.remove(...inputErrorClasses)
        ref.current.parentElement.classList.remove(...labelErrorClasses)
        ref.current.parentElement.classList.add("before:content-none")

        dispatch({ type: 'setCustomerData', payload: { name: [target.name], value: target.value } })
    }

    return (
        <label data-error-icon="!" data-error-msg={errorMessage} className={`flex-1 box-border relative after:text-[#FD6F64] after:text-[12px] after:font-semibold before:w-[20px] before:h-[20px] before:rounded-full before:bg-[#FF7062] before:text-white before:content-none before:flex before:items-center before:justify-center before:absolute before:z-10 before:right-[5px] ${extraClasses}`}>
            <div className={`uppercase font-normal after:content-['*'] after:text-brio-200`}>{srOnlyLabel && <span className='sr-only'>{srOnlyLabel}</span>}{label}</div>
            <input required ref={ref} name={name} value={state[name]} onChange={handleInputChange} className='text-muted-800 min-w-0 w-full py-2 px-4 rounded-xl' />
            {moreInfo && <label className="flex-1 w-full flex items-center text-[12px]" onClick={moreInfo.onclick}>
                <a className="border-b-white border-b border-solid font-light">
                   {moreInfo.text}
                </a>
            </label>}
        </label>
    )
})

export default FormTextInput